// 임시저장(초안) 로컬 저장소: 서버/알림과 무관하게 브라우저 localStorage 에만 보관.
// 첨부파일(File 객체)은 직렬화 불가라 제외하고 제목/카테고리/본문/모드만 저장한다.
import type { PostFormat } from '@shared/types';

export interface DraftData {
  title: string;
  categoryId: number;
  mode: PostFormat;
  content: string;
  savedAt: number; // epoch(ms)
}

export class DraftStore {
  private static readonly PREFIX = 'blog:draft:';
  private readonly key: string;

  // postId 가 null 이면 신규 글, 값이 있으면 해당 글 수정용 초안.
  constructor(postId: number | null) {
    this.key = DraftStore.PREFIX + (postId == null ? 'new' : String(postId));
  }

  public save(data: DraftData): void {
    localStorage.setItem(this.key, JSON.stringify(data));
  }

  public load(): DraftData | null {
    const raw = localStorage.getItem(this.key);
    if (!raw) return null;
    // 손상된 초안은 무시하고 정리(로컬 저장소 경계에서만 최소 방어)
    const parsed = DraftStore.tryParse(raw);
    if (!parsed) this.clear();
    return parsed;
  }

  public clear(): void {
    localStorage.removeItem(this.key);
  }

  private static tryParse(raw: string): DraftData | null {
    try {
      const v = JSON.parse(raw) as DraftData;
      if (typeof v?.title !== 'string' || typeof v?.content !== 'string') return null;
      return v;
    } catch {
      return null;
    }
  }
}
